import React, { useState, useEffect } from 'react';
import axios from 'axios'; // For HTTP requests
import Loader from '../../Components/Loader'; // For loading state

function StudentClasses() {
    const [classesData, setClassesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchClassesData = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    throw new Error("Authentication token is missing");
                }
    
                const response = await axios.get(
                    "https://api.uniums.com/api/student/student-subjects-faculties",
                    { headers: { Authorization: `Bearer ${token}` } }
                );
    
                if (response.data && response.data.data) {
                    setClassesData(response.data.data);
                } else {
                    throw new Error("Invalid API response");
                }
            } catch (err) {
                console.error("Frontend Error:", err.response?.data || err.message);
                setError(err.response?.data?.error || err.message);
            } finally {
                setLoading(false);
            }
        };
    
        fetchClassesData();
    }, []);
    

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div className="error-message">Error: {error}</div>;
    }

    return (
        <div className="faculty-dashboard">
          <h1>Student Classes and Faculty</h1>
        <div className='attendance-table-container'>
            <table className="attendance-table">
                <thead>
                    <tr>
                        <th>Sl. No</th>
                        <th>Subject</th>
                        <th>Faculty Name</th>
                        <th> Faculty Mobile No.</th>
                    </tr>
                </thead>
                <tbody>
                    {classesData.length > 0 ? (
                        classesData.map((data, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.subject}</td>
                                <td>{data.facultyName}</td>
                                <td>{data.organizationContact || "Not Available"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center' }}>
                                No classes or faculty data available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        </div>
    );
}

export default StudentClasses;
